import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultImageDirective, FetchProfileImageDirective } from '@shared/directives';
import { HumanizePipe } from '@shared/pipes';
import { TranslateModule } from '@ngx-translate/core';
import { GroupNewsEntity } from '@core/entities';
import { DialogService } from '@ngneat/dialog';
import { NgxBottomSheetService } from 'ngx-bottom-sheet';
import { isMobileView } from '@core/utils';
import { IconComponent } from '@shared/components/ui';
import { NewsDetailsComponent } from '@shared/components';
import { Router } from '@angular/router';

@Component({
  selector: 'app-group-news-card',
  imports: [CommonModule, DefaultImageDirective, IconComponent, HumanizePipe, TranslateModule, FetchProfileImageDirective],
  templateUrl: './group-news-card.component.html',
  styleUrls: ['./group-news-card.component.scss'],
})
export class GroupNewsCardComponent {
  private readonly _dialogService = inject(DialogService);
  private readonly _bottomSheetService = inject(NgxBottomSheetService);
  private readonly _router = inject(Router);

  private _groupNews = new GroupNewsEntity();

  get groupNews(): GroupNewsEntity {
    return this._groupNews;
  }

  @Input() set groupNews(value: GroupNewsEntity) {
    this._groupNews = value;
  }

  navigateToGroupDetailsScreen() {
    this._router.navigate([`/groups/${this.groupNews.group.id}/details`]);
  }

  openGroupNewsDetailDialogBox() {
    if (!isMobileView()) {
      this._dialogService.open(NewsDetailsComponent, {
        size: 'md',
        closeButton: false,
        width: '620px',
        windowClass: 'dialog-overflow-unset dialog-overflow-y-auto',
        data: { news: this.groupNews.news },
      });
    } else {
      this._bottomSheetService.open(NewsDetailsComponent, {
        height: '95%',
        showCloseButton: false,
        data: {
          news: this.groupNews.news,
        },
      });
    }
  }
}
